import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { setJobTargetIcon } from '../../constants-types/constants';
import {
    SendAssessmentFlowType,
    GlobalEmailTypes
} from '../../constants-types/Enums';
// TODO: We need to decouple this from directly calling the service. This one service
// pulls in easily 20-50 other dependencies. Maybe use a global event bus
import { AssessmentReminderConfig } from '../../core-data-model/AssessmentReminderConfig';
import { AssessmentCenterService } from '../../core-services/AssessmentCenter.service';
import { notification } from '../../core-services/Notifications.service';
import { SetJobTargetFlowDataService } from '../../core-services/SetJobTargetFlow.dataservice';
import { InitDataService } from '../../system-services/InitData/InitData.service';
import { TranslationService } from '../../translations';

@Component({
    selector: 'assessment-reminder-v2',
    template: `
        @if (
            (properties.personOrJob && properties.personOrJob.isPerson) ||
            properties.jobAssessment
        ) {
            <div>
                @if (properties.reminderType !== FlowType.Send) {
                    <div class="microTableLine">
                        {{ TR.key('label.common-terms.sent') }}:<span
                            class="text-bold"
                            style="margin-left: 3px"
                            >{{ properties.dateSent }}</span
                        >
                    </div>
                }
                <div class="microTableLine">
                    @if (showExpired()) {
                        <span class="errorColor">
                            {{ TR.key('label.common-terms.expired') }}
                        </span>
                    }
                    @if (!initData.isReadOnly()) {
                        <a
                            class="lsg-link"
                            (click)="openSendAssessment($event)"
                        >
                            {{ buttonText }}
                        </a>
                    }
                </div>
                @if (properties.reminderType === FlowType.Sent) {
                    <span
                        class="pi-sendAssessmentPromptBox_littleTag littleTag--progress"
                    >
                        {{ TR.key('label.common-terms.sent') }}
                    </span>
                }
            </div>
        } @else {
            <div
                class="pi-sendAssessmentPromptBox pi-sendAssessmentPromptBox--job"
                (click)="goToModifyJobTarget()"
                tooltip
                [tooltipDisabled]="true"
            >
                <i class="fa" [ngClass]="setJobTargetIcon"></i>
                {{ TR.key('jobDashboard.setJobTargetButton') }}
            </div>
        }
    `,
    standalone: false
})
export class AssessmentOrJobTargetReminderV2Component {
    @Input()
    properties: AssessmentReminderConfig;
    @Output()
    dataChange = new EventEmitter();
    @Output()
    sendStrategyAssessment = new EventEmitter();

    public FlowType = SendAssessmentFlowType;
    GlobalEmailTypes = GlobalEmailTypes;

    setJobTargetIcon = setJobTargetIcon;

    constructor(
        public TR: TranslationService,
        private assessmentCenterService: AssessmentCenterService,
        private setJobTargetFlowDataService: SetJobTargetFlowDataService,
        private router: Router,
        public initData: InitDataService
    ) {}

    get buttonText() {
        return this.canSendAgain()
            ? this.TR.key('text.common-terms.send.again')
            : this.TR.key('common.sendNewAssessment');
    }

    async openSendAssessment(event: MouseEvent) {
        event.stopPropagation();
        if (
            this.properties.behavioralType ===
            GlobalEmailTypes.JobAssessmentEmail
        ) {
            return this.setJobTargetFlowDataService.sendReminder(
                this.properties.jobAssessment
            );
        } else if (
            this.properties.behavioralType ===
            GlobalEmailTypes.StrategyAssessmentEmail
        ) {
            this.sendStrategyAssessment.emit();
        } else {
            // Resend is supported for BA
            if (this.canSendAgain()) {
                return this.resend();
            } else {
                return this.assessmentCenterService.openSendAssessment(
                    this.properties.personOrJob.id,
                    this.properties.behavioralType
                );
            }
        }
    }

    canSendAgain(): boolean {
        return (
            (this.properties.behavioralType ===
                GlobalEmailTypes.BehavioralAssessmentEmail &&
                this.properties.reminderType !== SendAssessmentFlowType.Send) ||
            this.properties.behavioralType ===
                GlobalEmailTypes.StrategyAssessmentEmail
        );
    }
    showExpired(): boolean {
        return (
            this.properties.reminderType ===
                SendAssessmentFlowType.SendAgainExpired &&
            this.properties.behavioralType !==
                GlobalEmailTypes.StrategyAssessmentEmail
        );
    }

    @notification('notification.title-success')
    private async resend() {
        await this.assessmentCenterService.openResendAssessment(
            this.properties.behavioralType,
            this.properties.assessmentId
        );
        this.dataChange.emit();
    }

    goToModifyJobTarget() {
        return this.setJobTargetFlowDataService
            .selectJobToTarget(
                this.properties.personOrJob.id,
                `/modifyJob/${this.properties.personOrJob.id}`
            )
            .then((routerParams) => this.router.navigate(routerParams));
    }
}
